import { render, staticRenderFns } from "./ComparatorPage.vue?vue&type=template&id=f23ace48&scoped=true"
import script from "./ComparatorPage.vue?vue&type=script&lang=js"
export * from "./ComparatorPage.vue?vue&type=script&lang=js"
import style0 from "./ComparatorPage.css?vue&type=style&index=0&id=f23ace48&prod&lang=css&scoped=true&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f23ace48",
  null
  
)

export default component.exports